import { Alert02Icon } from '@hugeicons/core-free-icons'
import { HugeiconsIcon } from '@hugeicons/react'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { BlocoCodigo } from '@/components/ui/bloco-codigo'

/**
 * Erro inesperado: mostra uma mensagem clara e, se houver, o detalhe técnico
 * (traceback) escondido num "Ver detalhes" para quem precisar investigar.
 */
function BlocoExcecao({
  titulo = 'Algo deu errado',
  mensagem,
  detalhe,
}: {
  titulo?: string
  mensagem: string
  detalhe?: string
}) {
  return (
    <Alert variant="error" role="alert">
      <HugeiconsIcon icon={Alert02Icon} strokeWidth={2} />
      <AlertTitle>{titulo}</AlertTitle>
      <AlertDescription>
        <p>{mensagem}</p>
        {detalhe ? (
          <details className="mt-2">
            <summary className="cursor-pointer text-xs underline-offset-4 hover:underline">
              Ver detalhes
            </summary>
            <BlocoCodigo className="mt-2 text-foreground">{detalhe}</BlocoCodigo>
          </details>
        ) : null}
      </AlertDescription>
    </Alert>
  )
}

export { BlocoExcecao }
